import React from 'react'
import { useTranslation } from 'react-i18next'
import { useEvaluationResult } from './useEvaluationResult'
import InfoItem from 'components/PackageBuilder/Results/shared/InfoItem'
import moment from 'moment'

import { Table } from 'react-bootstrap'
import { numberWithThousandsSeparatorsWithCurrencyPrefix } from 'utils/helpers'
import ErrorMessage from 'components/Shared/ErrorMessage'
import { BACKHAUL_ATTRIBUTION_MODELS } from 'api/backhaulAttribution'
import Notice from 'components/Shared/Notice'


function EvaluationResult({ reloadKey, backhaulAttribution }) {
  const { t } = useTranslation()
  const { getInfo, currency, evaluationData, error } = useEvaluationResult(reloadKey)

  if (error) {
    return <ErrorMessage>Error fetching evaluation data</ErrorMessage>
  }

  const TRANSLATION_KEYS = {
    [BACKHAUL_ATTRIBUTION_MODELS.ALL_PURCHASES]: 'PackageBuilder.packageBuilderResults.evaluationModal.modelType.allPurchases',
    [BACKHAUL_ATTRIBUTION_MODELS.EVENTS_FROM_PACKAGE]: 'PackageBuilder.packageBuilderResults.evaluationModal.modelType.eventsFromPackage',
    [BACKHAUL_ATTRIBUTION_MODELS.EVENT_SERIES]: 'PackageBuilder.packageBuilderResults.evaluationModal.modelType.eventSeries',
  }

  // in case of no date for entered attribution values BE will return a message
  if (evaluationData?.message) {
    return <Notice 
      message={t(
        'PackageBuilder.packageBuilderResults.evaluationResults.noDataMessage',
        { 
          attributionWindow: backhaulAttribution.backhaul_evaluation_attribution_window,
          model: t(
            TRANSLATION_KEYS[backhaulAttribution.backhaul_evaluation_model],
          ),
          emailSentDate: backhaulAttribution.email_sent_date ? moment.utc(backhaulAttribution.email_sent_date).format('DD.MM.YYYY') : '-',
        }
      )} 
      isVisible={true} 
      className="mb-3"
    />
  }

  if (!evaluationData || Object.keys(evaluationData).length === 0) {
    return null
  }


  // return
  return (
    <div className="package-builder-page_results_section-wrapper package-builder-page_results_evaluation-result">
      <div className="package-builder-page_results_section-wrapper_header flex-column align-items-start">
        <p className="package-builder-page_results_section-wrapper_header_title mb-2">Result</p>

        <div className="d-flex flex-row gap-2 flex-wrap">
          <p>
            {t('PackageBuilder.packageBuilderResults.evaluationResults.emailSent')}:{' '}
            {moment.utc(backhaulAttribution.email_sent_date).format('DD.MM.YYYY')};
          </p>

          <p>
            {t('PackageBuilder.packageBuilderResults.evaluationModal.attributionwindow')}:{' '}
            {backhaulAttribution.backhaul_evaluation_attribution_window};
          </p>

          <p>
            {t('PackageBuilder.packageBuilderResults.evaluationModal.model')}:{' '}
            {t(
              TRANSLATION_KEYS[backhaulAttribution.backhaul_evaluation_model],
            )}
          </p>
        </div>
      </div>

      <div className="package-builder-page_results_section-wrapper_content">
        <div className="info-list">
          {getInfo(evaluationData).map((item) => (
            <InfoItem key={item.title} info={item} />
          ))}
        </div>

        <div className="evaluation-result-table">
          <Table responsive className="mb-0">
            <thead>
              <tr>
                <th className="col-taste-cluster">Taste Cluster</th>
                <th className="col-info">{t('PackageBuilder.packageBuilderResults.evaluationResults.customers')}</th>
                <th className="col-info">{t('PackageBuilder.packageBuilderResults.evaluationResults.items')}</th>
                <th className="col-info">{t('PackageBuilder.packageBuilderResults.evaluationResults.revenue')}</th>
              </tr>
            </thead>
          
            <tbody>
              {Object.entries(evaluationData || {}).map(([clusterName, clusterData]) => (
                <tr key={clusterName}>
                  <td className="col-taste-cluster">{clusterName}</td>
                  <td className="col-info">{clusterData.customers}</td>
                  <td className="col-info">{clusterData.items ?? '-'}</td>
                  <td className="col-info">
                    {`${numberWithThousandsSeparatorsWithCurrencyPrefix(clusterData.purchase)} ${currency}`}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  )
}

export default EvaluationResult